/* eslint-disable typescript-sort-keys/interface */
/* eslint-disable @typescript-eslint/method-signature-style */
/* eslint-disable @typescript-eslint/consistent-type-definitions */
/**
 * The purpose of this utility is to avoid plugin extend duplication
 * and keep all dayjs config and plugins at one place
 */
import originalDayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
import calendar from 'dayjs/plugin/calendar.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import duration from 'dayjs/plugin/duration.js';
import isBetween from 'dayjs/plugin/isBetween.js';
import isToday from 'dayjs/plugin/isToday.js';
import isYesterday from 'dayjs/plugin/isYesterday.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';
/* eslint-disable import/no-named-as-default-member */
originalDayjs.extend(advancedFormat);
originalDayjs.extend(relativeTime);
originalDayjs.extend(duration);
originalDayjs.extend(calendar);
originalDayjs.extend(isYesterday);
originalDayjs.extend(isToday);
originalDayjs.extend(isBetween);
originalDayjs.extend(customParseFormat);
/* eslint-enable import/no-named-as-default-member */
// https://github.com/iamkun/dayjs/issues/297#issuecomment-1741859319
// eslint-disable-next-line unicorn/prefer-export-from
export const dayjs = originalDayjs;
//# sourceMappingURL=index.js.map